<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div class="ts-space-x-2">
        <ts-button outline color="info" @click.prevent="addNew">
          {{ $t('add_new') }}
        </ts-button>
        <ts-button outline @click.prevent="onDownloadTemplate">
          {{ $t('task.downLoadTempate') }}
        </ts-button>
        <ts-button outline @click="onClickBrowse">
          {{ $t('task.uploadActionTask') }}
        </ts-button>

        <input
          type="file"
          ref="refFile"
          @change="fileChange"
          class="ts-hidden"
        />
      </div>

      <div>
        <Input
          v-model="search"
          suffix="ios-search"
          placeholder="Search|Title,Owner"
          style="width: auto"
          @on-change="fetchData"
        />
      </div>
    </div>
    <div class="ts-h-3"></div>
    <Table
      :columns="columns"
      :data="resources"
      :loading="loading"
      size="small"
      fixed-shadow="hide"
      max-height="700"
    >
      <template slot-scope="{ row }" slot="title">
        <a
          href="#"
          v-if="row.file_storage_path"
          @click.prevent="onViewFile(row)"
        >
          {{ row.title }}
          <i class="fas fa-paperclip"></i>
        </a>
        <span v-else>{{ row.title }}</span>
      </template>
      <template slot-scope="{ row }" slot="estimate">
        <div style="width: fit-content;" v-if="row.estimate_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.estimate_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.estimate_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actual">
        <div style="width: fit-content;" v-if="row.actual_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.actual_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.actual_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="latlng">
        <a
          target="_blank"
          :href="`https://maps.google.com/?q=${row.latitude},${row.longitude}`"
        >
          {{ row.latitude + '-' + row.longitude }}
        </a>
      </template>
      <template slot-scope="{ row }" slot="actions">
        <div
          class="ts-flex ts-space-x-2 ts-items-center"
          style="width: fit-content;"
        >
          <a
            href="#"
            class="text-primary ts-relative"
            @click.prevent="onShowReport(row)"
            v-tooltip="$t('task.report')"
          >
            <div
              v-if="row.reports_count"
              class="ts-absolute ts-right-0 ts-top-0 ts-mr-2 ts-h-2 ts-w-2 ts-bg-red-600 ts-rounded-full"
            ></div>
            <i class="fas fa-file-signature ts-text-base ts-mr-2"></i>
          </a>
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <a
            href="#"
            class="text-danger"
            v-tooltip="$t('delete')"
            @click="deleteRecord(row)"
            :disabled="row._deleting"
          >
            <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
            <Icon type="ios-trash" size="20" v-else />
          </a>
        </div>
      </template>
    </Table>
    <iModalWrapper v-model="isCreateNew" :title="$t('create')">
      <CreateForm v-if="isCreateNew" @close="onCloseModal" />
    </iModalWrapper>
    <iModalWrapper v-model="isUpdate" :title="$t('update')">
      <EditForm :edit_data="edit_data" v-if="isUpdate" @close="onCloseModal" />
    </iModalWrapper>
    <iModalWrapper
      v-model="isShowReport"
      :title="$t('task.report')"
      width="90%"
      :zIndex="1010"
    >
      <ReportOnSubTask
        :edit_data="edit_data"
        v-if="isShowReport"
        @close="onCloseModal"
      />
    </iModalWrapper>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import * as XLSX from 'xlsx/xlsx.mjs'
import { debounce, trim } from 'lodash'
import * as FileDownload from 'downloadjs'
import EditForm from './edit-sub-task-form.vue'
import CreateForm from './create-sub-task-form.vue'
import ReportOnSubTask from './report-on-sub-task.vue'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
export default {
  components: {
    CreateForm,
    EditForm,
    iModalWrapper,
    ReportOnSubTask
  },
  data() {
    return {
      resources: [],
      edit_data: [],
      loading: false,
      isCreateNew: false,
      isUpdate: false,
      isShowReport: false,
      search: '',
      model: {
        subtasks: []
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('task.title'),
          slot: 'title',
          sortable: true,
          minWidth: 200,
          className: 'ts-font-robot ts-font-hanuman',
          fixed: 'left'
        },
        {
          title: this.$t('task.owner'),
          key: 'owner_name',
          sortable: true,
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.status'),
          key: 'project_status',
          sortable: true,
          width: 120,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.estimated'),
          slot: 'estimate',
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.actual'),
          slot: 'actual',
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.latLng'),
          slot: 'latlng',
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.remark'),
          key: 'remark',
          minWidth: 120,
          className: 'ts-font-robot ts-font-hanuman',
          fixed: 'left'
        },
        {
          title: this.$t('actions'),
          slot: 'actions',
          fixed: 'right',
          align: 'left',
          className: 'ts-font-robot',
          width: 130
        }
      ]
    }
  },
  created() {
    this.fetchSubTask()
  },
  methods: {
    ...mapActions('projectMgt/subTaskProfile', [
      'fetch',
      'destroy',
      'importSub',
      'downloadTemplate'
    ]),
    addNew() {
      this.isCreateNew = true
    },
    fetchSubTask() {
      if (this.resources.length == 0) {
        this.fetchData()
      }
    },
    fetchData: debounce(function() {
      this.loading = true
      const id = this.$route.params.id
      this.fetch({
        id,
        params: {
          search: this.search
        }
      })
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }, 600),
    onCloseModal() {
      this.isCreateNew = false
      this.isUpdate = false
      this.fetchData()
    },
    deleteRecord(record) {
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onEdit(record) {
      this.isUpdate = true
      this.edit_data = record
    },
    onViewFile(record) {
      window.open(record.file_storage_path_read, '_blank')
    },
    onShowReport(row) {
      this.isShowReport = true
      this.edit_data = row
    },
    onClickBrowse() {
      this.$refs.refFile.click()
    },
    fileChange(e) {
      this.loading = true
      var file = e.target.files[0]
      var fileName = file.name
      this.model.subtasks = []
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        const taskId = this.$route.params.id
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const workbookData = this.parseWorksheetData(worksheet)
          const sliceFirstRow = workbookData.slice(1)
          if (sliceFirstRow.length > 5) {
            sliceFirstRow.slice(6).forEach(item => {
              this.model.subtasks.push({
                task_profile_id: taskId,
                title: item[0],
                status_id: item[1] ? item[1] : null,
                response_by_id: item[3] ? item[3] : null,
                estimate_start_date: item[4]
                  ? this.excelDateToJSDate(item[4])
                  : null,
                estimate_end_date: item[5]
                  ? this.excelDateToJSDate(item[5])
                  : null,
                actual_start_date: item[6]
                  ? this.excelDateToJSDate(item[6])
                  : null,
                actual_end_date: item[7]
                  ? this.excelDateToJSDate(item[7])
                  : null,
                latitude: item[8] ? item[8] : null,
                longitude: item[9] ? item[9] : null,
                remark: item[10] ? item[10] : ''
              })
            })

            this.importSub(this.model)
              .then(() => this.fetchData())
              .catch(error => {
                const errorValue = Object.values(error.errors)
                this.$toasted.error(
                  errorValue.length ? errorValue.join('|') : error.message
                )
                this.$refs.refFile.value = null
              })
              .finally(() => (this.loading = false))
          }
        }
      }
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          const cell = worksheet[cellAddress]

          if (cell) {
            // const cellValue = cell ? cell.v : undefined
            row[colNum] = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push(row)
        }
      }
      return jsonData
    },
    excelDateToJSDate(excelDate) {
      // Adjust for difference in epoch (reference date)
      const EPOCH_DIFF = excelDate >= 1900 ? 25569 : 25568 // Adjust for 1900 vs 1904 epoch difference

      // Convert to milliseconds since epoch
      const milliseconds = (excelDate - EPOCH_DIFF) * 86400000

      // Create a new JavaScript Date object
      return moment(new Date(milliseconds), 'YYYY-MM-DD').format('YYYY-MM-DD')
    },
    onDownloadTemplate() {
      this.loading = true
      this.downloadTemplate()
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename + '.xlsx')
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
